import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="no-print" style={{ borderTop: '1px solid #e0e4ea', background: '#fff', padding: '20px 24px', textAlign: 'center' }}>
            <Link to="/privacy" style={{ fontSize: '0.8rem', color: '#6b7280', textDecoration: 'none' }}>
                プライバシーポリシー
            </Link>
            <p style={{ fontSize: '0.8rem', color: '#9ca3af', margin: '8px 0 0' }}>
                © 2024 のりいれ三丁目. All rights reserved.
            </p>
        </footer>
    );
};

export default Footer;
